const OrgProjectsTabs = [
  {
    key: "pre-sales",
    label: "Pre-Sales",
  },
  {
    key: "post-sales",
    label: "Post-Sales",
  },
  {
    key: "completed",
    label: "Completed",
  },
];

export default OrgProjectsTabs;
